import { TableKeys } from 'src/app/models/table'
import { Status } from 'src/api/models';

export const LicenseTableKeys: Array<TableKeys> = [
  {
    title: 'Number',
    key: 'licenseNumber',
    columnType: 'default'
  },
  {
    title: 'Status',
    key: 'status',
    columnType: 'status'
  },
  {
    title: 'Issue Date',
    key: 'issuedDate',
    columnType: 'date'
  },
  {
    title: 'Expiry Date',
    key: 'expiredDate',
    columnType: 'date'
  },
  {
    title: 'Price',
    key: 'price',
    columnType: 'default'
  },
];

export const CertificateTableKeys: Array<TableKeys> = [
  {
    title: 'Name',
    key: 'certificateName',
    columnType: 'default'
  },
  {
    title: 'Status',
    key: 'status',
    columnType: 'status'
  },
  {
    title: 'Issue Date',
    key: 'issuedDate',
    columnType: 'date'
  },
  {
    title: 'Expiry Date',
    key: 'expiredDate',
    columnType: 'date'
  }
];